import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // A prévia do cache some assim que a página nova chega: anúncio pedido nela não é visto.
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    this.originalStyle ??= this.element.getAttribute("style")
    this.reset = () => this.#reset()
    document.addEventListener("turbo:before-cache", this.reset)

    // Só inicializa se ainda não foi processado pelo AdSense
    if (this.element.dataset.adsbygoogleStatus) return

    // Bloco escondido por media query (a lateral fixa abaixo de 1440px): sem largura o AdSense
    // recusa o push ("No slot size for availableWidth=0") e o pedido só gera erro no console.
    if (this.element.offsetWidth === 0) return

    try {
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch (e) {
      // AdSense não disponível (ex: bloqueado por ad blocker ou ambiente local)
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset)
  }

  // Sem isto o snapshot do Turbo guarda o iframe já preenchido e o <ins> marcado como "done":
  // ao voltar pelo navegador, o guarda do connect() pula o push e o bloco fica com o anúncio
  // velho. Devolvido ao estado do HTML, o bloco pede um anúncio novo quando a página reaparece.
  #reset() {
    this.element.replaceChildren()
    this.element.removeAttribute("data-adsbygoogle-status")
    this.element.removeAttribute("data-ad-status")

    if (this.originalStyle === null) {
      this.element.removeAttribute("style")
    } else {
      this.element.setAttribute("style", this.originalStyle)
    }
  }
}
